import { useQuery } from "@tanstack/react-query";
import { getPositionTypes } from "@/Services/institutions.service";
import type { InstitutionScope } from "../types";

export function useInstitutionPositionTypes(
  institutionId: string | undefined,
  scope?: InstitutionScope,
) {
  return useQuery({
    queryKey: ["institution-position-types", institutionId, scope],
    queryFn: () => getPositionTypes(institutionId!, scope),
    enabled: !!institutionId,
    staleTime: 10 * 60 * 1000,
  });
}
